module.exports = __webpack_public_path__ + "img/4.aa8db2bb.svg";